import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const WatchtowerParameterRBAC = {
  pageID: 'b85ed0b35bc4eb6654aef47244baa542',
  elementID: {
    ViewParameter: 'd23f08a3cc3af81b63adb2c63e38ed34',
    CreateParameter: '5315fb826f9e13003860e7970d29da4f',
    EditParameter: '9d2794dcd4e40e527d0e687c279700c7',
  },
} as const

export const useWatchtowerParameterRBACPage = createUseRBAC(WatchtowerParameterRBAC.elementID)

export type UseWatchtowerParameterRBACPageType = ReturnType<typeof useWatchtowerParameterRBACPage>
